import { render } from "./rank-item.vue?vue&type=template&id=6ec7cdae&ts=true"
import script from "./rank-item.vue?vue&type=script&lang=ts"
export * from "./rank-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__